import { render, staticRenderFns } from "./ProgramActivityReminderUpdate.vue?vue&type=template&id=ae82741c&scoped=true"
import script from "./ProgramActivityReminderUpdate.vue?vue&type=script&lang=js"
export * from "./ProgramActivityReminderUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProgramActivityReminderUpdate.vue?vue&type=style&index=0&id=ae82741c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae82741c",
  null
  
)

export default component.exports